var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-part6"},[_c('centerTitle',{staticClass:"mt-20",attrs:{"type":"1","title":"趋势列表"}}),_c('div',{staticClass:"p-content"},[(_vm.showczxhqs)?_c('myEchart',{attrs:{"id":'showczxhqs',"options":_vm.batteryChargingData}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }